// extracted by mini-css-extract-plugin
export var bg = "HeroBackgroundImageBase-module--bg--ZC3d2";